import c from "./index.es472.js";
function r(e, t) {
  var n = t.sheetId, o = t.sheetImages;
  return "sheet".concat(n, "-image").concat(o.indexOf(e) + 1, ".").concat(c(e.contentType));
}
export {
  r as default
};
//# sourceMappingURL=index.es424.js.map
